// extracted by mini-css-extract-plugin
export var caretAnchor = "_vc-0";
export var dropdownContent = "_vc-1";